import settings from './settings';
import { nanoid } from 'nanoid';
const temp = [
  '',
  'https://avatars.mds.yandex.net/get-pdb/1938902/53d74ac0-9362-49e7-b565-aa5e57b8cdf3/s1200?webp=false',
  ''
];
const batteryLvL = [3, 40, 70, 100];
const batteryType = ['DC', 'Half battery', 'Low battery', undefined];
export default {
  namespaced: true,
  modules: {
    settings
  },
  state: {
    data: []
  },
  getters: {
    columns(state) {
      return state.settings.data.map(i => {
        return {
          value: i,
          text: i
        };
      });
    }
  },

  actions: {
    load({ commit }, params) {
      if (!params) {
        const list = [];
        list.length = 40;
        list.fill({
          id: 1,
          name: 'App',
          avatar: '',
          favorit: false,
          muted: false,
          status: 'Enabled',
          column3: 'value',
          rawEntity: [
            {
              id: nanoid(),
              subheader: 'Groups',
              type: 'tags',
              properties: [
                {
                  id: nanoid(),
                  title: 'Group #1',
                  link: ''
                },
                {
                  id: nanoid(),
                  title: 'Group #2',
                  link: ''
                },
                {
                  id: nanoid(),
                  title: 'Group #3',
                  link: ''
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Meta info',
              properties: [
                {
                  id: nanoid(),
                  title: 'Contact',
                  subtitle: 'Contact info',
                  icon: 'mdi-account',
                  alias: 'userEmail',
                  contextMenu: true
                },
                {
                  id: nanoid(),
                  title: 'Email',
                  subtitle: 'example@mail.con',
                  icon: 'mdi-email',
                  alias: 'userEmail',
                  contextMenu: true
                },
                {
                  id: nanoid(),
                  title: 'Phone',
                  subtitle: '+1 000 000',
                  icon: 'mdi-phone',
                  alias: 'userPhone',
                  contextMenu: true
                },
                {
                  id: nanoid(),
                  title: 'Second ID',
                  subtitle: nanoid(),
                  icon: 'mdi-at',
                  alias: 'userSecondId',
                  contextMenu: true
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Variables',
              properties: [
                {
                  id: nanoid(),
                  title: 'Variables',
                  isNeedGap: false
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Tags',
              type: 'tags',
              properties: [
                {
                  id: nanoid(),
                  title: 'tag #1',
                  link: ''
                },
                {
                  id: nanoid(),
                  title: 'tag #2',
                  link: ''
                },
                {
                  id: nanoid(),
                  title: 'tag #3',
                  link: ''
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Description',
              properties: [
                {
                  id: nanoid(),
                  title: 'App description',
                  isNeedGap: false
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'UUID',
              properties: [
                {
                  id: nanoid(),
                  title: 'UUID',
                  isNeedGap: false
                }
              ]
            }
          ]
        });
        commit(
          'set',
          list.map((i, n) => {
            return {
              ...i,
              id: i.id + n,
              name: `${i.name} ${n}`,
              avatar: temp[n] ? temp[n] : 'mdi-security'
            };
          })
        );
        commit(
          'settings/set',
          Object.keys(list[0]).filter(i => i !== 'avatar' && i !== 'rawEntity')
        );
      }
    }
  }
};
